/**
 * 应用标题（可分别配置）
 * - VUE_APP_APP_TITLE       侧边栏标题
 * - VUE_APP_LOGIN_TITLE     登录页标题
 * - VUE_APP_DOCUMENT_TITLE  浏览器标签页标题（未设则同侧边栏）
 * - VUE_APP_HOME_TITLE      首页欢迎语（未设则「欢迎您进入{侧边栏标题}」）
 *
 * 生产：各 .env.* 中配置
 * 开发：登录页切换环境时，与 dev-api-envs.json 联动
 */
import devApiEnvs from './dev-api-envs.json'

const ENV_STORAGE_KEY = 'laundry_dev_api_env'
const IS_DEV = process.env.NODE_ENV !== 'production'

const DEFAULT_APP_TITLE = '喜鹊系统'
const DEFAULT_LOGIN_TITLE = '喜鹊洗衣系统'
const DEFAULT_HOME_TITLE = '欢迎您进入洗衣管理系统'

function readDevEnvKey() {
  if (typeof window === 'undefined' || !IS_DEV) {
    return ''
  }
  try {
    return localStorage.getItem(ENV_STORAGE_KEY) || ''
  } catch (e) {
    return ''
  }
}

function buildHomeTitleFallback(appTitle) {
  if (!appTitle) {
    return DEFAULT_HOME_TITLE
  }
  return `欢迎您进入${appTitle}`
}

function resolveAppTitles() {
  const envAppTitle = process.env.VUE_APP_APP_TITLE || DEFAULT_APP_TITLE
  const envLoginTitle = process.env.VUE_APP_LOGIN_TITLE || DEFAULT_LOGIN_TITLE
  const envDocumentTitle =
    process.env.VUE_APP_DOCUMENT_TITLE || envAppTitle
  const envHomeTitle =
    process.env.VUE_APP_HOME_TITLE || buildHomeTitleFallback(envAppTitle)

  if (IS_DEV) {
    const key = readDevEnvKey()
    if (key) {
      const found = devApiEnvs.find((item) => item.key === key)
      if (found) {
        const appTitle = found.appTitle || envAppTitle
        return {
          appTitle,
          loginTitle: found.loginTitle || envLoginTitle,
          documentTitle:
            found.documentTitle || found.appTitle || envDocumentTitle,
          homeTitle:
            found.homeTitle ||
            buildHomeTitleFallback(found.appTitle || envAppTitle),
        }
      }
    }
  }

  return {
    appTitle: envAppTitle,
    loginTitle: envLoginTitle,
    documentTitle: envDocumentTitle,
    homeTitle: envHomeTitle,
  }
}

const resolved = resolveAppTitles()

/** 侧边栏标题 */
export const APP_TITLE = resolved.appTitle
/** 登录页标题 */
export const LOGIN_TITLE = resolved.loginTitle
/** 浏览器标签页标题 */
export const DOCUMENT_TITLE = resolved.documentTitle
/** 首页欢迎标题 */
export const HOME_TITLE = resolved.homeTitle

export function applyDocumentTitle() {
  if (typeof document !== 'undefined') {
    document.title = DOCUMENT_TITLE
  }
}
